import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://newgate-backend.vercel.app/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if it exists
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const adminToken = localStorage.getItem('adminToken');
    
    if (token && !config.url.includes('/admin')) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (adminToken && config.url.includes('/admin')) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('adminToken');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  adminLogin: (data) => api.post('/admin/auth/login', data),
};

// Customer APIs
export const customerAPI = {
  getEnquiries: () => api.get('/enquiries'),
  createEnquiry: (data) => api.post('/enquiries', data),
  getQuotes: () => api.get('/quotes'),
  signQuote: (id) => api.post(`/quotes/${id}/sign`),
};

// Admin APIs
export const adminAPI = {
  getDashboard: () => api.get('/admin/dashboard'),
  getUsers: () => api.get('/admin/users'),
  getEnquiries: () => api.get('/admin/enquiries'),
  respondToEnquiry: (id, data) => api.post(`/admin/enquiries/${id}/respond`, data),
  getQuotes: () => api.get('/admin/quotes'),
  createQuote: (data) => api.post('/admin/quotes/create', data),
  exportData: (type, params) => api.get(`/admin/export/${type}`, { params }),
};

export default api;